import User, { hasRole, Role } from '@/models/User'
import Water from '@/models/Water'

export default class WaterPolicy {
    viewAny(_user: User) {
        return false
    }

    view(user: User, water: Water) {
        switch (user.role) {
            case Role.USER:
                return user.company?.id === water.entry.catalog.company.id
            case Role.AUDITOR:
                return user.auditor?.id === water.entry.catalog.auditor?.id
            default:
                return false
        }
    }

    create(user: User) {
        return hasRole(user, Role.USER)
    }

    update(user: User, water: Water) {
        return hasRole(user, Role.USER) && user.company?.id === water.entry.catalog.company.id
    }

    restore(user: User, water: Water) {
        return hasRole(user, Role.USER) && user.company?.id === water.entry.catalog.company.id
    }

    delete(user: User, water: Water) {
        return hasRole(user, Role.USER) && user.company?.id === water.entry.catalog.company.id
    }

    forceDelete(_user: User, _water: Water) {
        return false
    }
}
